export const generateEditLinkForCookiesAgreement = id => `/extras/cookiesAgreements/edit?agreementID=${id}`;